import * as tslib_1 from "tslib";
import { FileUploadControl } from "../../../src/common/controls/file-upload-control";
import { UploadStatus } from "../../../src/common/controls/upload-control";
import { Button, Icon, Modal, Upload, message, Spin } from "@h3/antd-vue";
import { Component } from "vue-property-decorator";
import FileList from "./file-list.vue";
import axios from "axios";
let PcUpload = class PcUpload extends FileUploadControl {
    constructor() {
        super(...arguments);
        this.previewVisible = false;
        this.previewImage = "";
        this.fileList = [];
        this.eventList = [];
        this.batchFileList = [];
        this.uploadFileList = [];
        this.largeUploadUrl = "";
        this.largeUploadHeaders = {};
        this.isDownloading = false;
        this.timer = null;
    }
    // return env.apiHost + '/api/aliyun/upload';
    showTip() {
        return false;
    }
    get listType() {
        // 上传图片为 picture-card 样式, 上传文件显示为 text 样式
        return this.isImage ? "picture-card" : "text";
    }
    get showBatchDownload() {
        return this.canBatchDownload && this.fileList.length > 0;
    }
    get canDounload() {
        const fileDown = this.fileList.filter((f) => {
            return f.status === "done" || f.status === 2;
        });
        if (fileDown.length === this.fileList.length) {
            return true;
        }
        else {
            return false;
        }
    }
    get isReadonly() {
        if (this.ctrl) {
            return this.readonly;
        }
        return true;
    }
    downloadChange(e) {
        if (e === 'start') {
            this.isDownloading = true;
        }
        else {
            this.isDownloading = false;
        }
    }
    handleUploadFile(file) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let flag = this.beforeUpload(file.file);
            if (flag === false)
                return false;
            let url1 = "/api/oss/upload/signurl";
            let headers = {};
            let param1 = {
                fileName: file.file.name,
                fileSize: file.file.size,
            };
            let res1 = yield axios.post(url1, param1, { headers });
            if (res1.errcode !== 0) {
                return false;
            }
            // 'Content-Type': 'multipart/form-data'
            let uploadHeaders = Object.assign({}, res1.data.headers, res1.data.metaData);
            let { refId, signUrl } = res1.data;
            // 上传
            let res2 = yield axios.put(signUrl, file.file, { headers: uploadHeaders });
            // 通知租户上传成功
            let url3 = "/api/oss/upload/success";
            let param3 = { refId: res1.data.refId };
            let res3 = yield axios.post(url3, param3);
            if (res3.errcode !== 0) {
                return;
            }
            else {
                let newFile = file.file;
                newFile.response = res3;
                newFile.percent = 100;
                newFile.status = "done";
                this.batchFileList.push(newFile);
                // 保存文件上传进度
                this.eventList = this.uploadFileList = this.uploadFileList.map((f) => {
                    const obj = this.batchFileList.filter((v) => {
                        if (v.uid === f.uid) {
                            return v;
                        }
                    });
                    return obj && obj.length > 0 ? obj[0] : f;
                });
                this.fileList = this.fileList.map((f) => {
                    const obj = this.batchFileList.filter((v) => {
                        if (v.uid === f.uid) {
                            return v;
                        }
                    });
                    return obj && obj.length > 0 ? obj[0] : f;
                });
                const files = this.fileList.filter((f) => f.status &&
                    !(f.status === "removed" || f.status === UploadStatus.Delete))
                    .map((f) => {
                    const obj = this.batchFileList.filter((v) => {
                        if (v.uid === f.uid) {
                            return v;
                        }
                    });
                    if (obj && obj.length > 0) {
                        f = obj[0];
                    }
                    let status = UploadStatus.Uploading;
                    switch (f.status) {
                        case "done":
                            status = UploadStatus.Done;
                            break;
                        case "error":
                            status = UploadStatus.Error;
                            break;
                        case "uploading":
                            status = UploadStatus.Uploading;
                            break;
                        default:
                            status = f.status;
                            break;
                    }
                    return {
                        uid: f.uid,
                        name: f.name,
                        size: f.size,
                        type: f.type,
                        status: status,
                        response: f.response,
                        url: '',
                        uploadTime: f.uploadTime,
                        uploadName: f.uploadName,
                    };
                });
                console.log('this.fileList', this.fileList);
                console.log('this.up', this.uploadFileList);
                // 不调用 super.onFilesChange(files);
                this.timer = setTimeout(() => {
                    _super("onFilesChange").call(this, files);
                }, 100);
            }
        });
    }
    // onChange 上传结束时不会调用onChange
    onChange(info) {
        let flag = this.beforeUpload(info.file);
        if (flag === false)
            return;
        clearTimeout(this.timer);
        if (this.isReadonly) {
            return;
        }
        this.uploadFileList = info.fileList.filter((f) => f.status && f.status !== "removed");
        if (this.uploadFileList.length === 0) {
            return;
        }
        //保存文件状态
        let { file } = info;
        const status = info.file.status;
        if (status === "done" && file.response && file.response.errcode === 0) {
            this.batchFileList.push(file);
        }
        // 保存文件上传进度
        this.eventList = this.uploadFileList = this.uploadFileList.map((f) => {
            if (f.response && f.response.errcode === 50000) {
                f.status = UploadStatus.Error;
            }
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            return obj && obj.length > 0 ? obj[0] : f;
        });
        const files = info.fileList
            .filter((f) => f.status &&
            !(f.status === "removed" || f.status === UploadStatus.Delete))
            .map((f) => {
            // 有服务errorcode = 50000 但是上传状态返回为done的情况 估计是上传接口先上传到服务器  再通过ftp还是oss转移到其他地方
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            if (obj && obj.length > 0) {
                f = obj[0];
            }
            let status = UploadStatus.Uploading;
            switch (f.status) {
                case "done":
                    status = UploadStatus.Done;
                    break;
                case "error":
                    status = UploadStatus.Error;
                    break;
                case "uploading":
                    status = UploadStatus.Uploading;
                    break;
                default:
                    status = f.status;
                    break;
            }
            return {
                uid: f.uid,
                name: f.name,
                size: f.size,
                type: f.type,
                status: status,
                response: f.response ? f.response : '',
                // response: f.response,
                url: "",
                uploadTime: f.uploadTime,
                uploadName: f.uploadName,
            };
        });
        this.timer = setTimeout(() => {
            super.onFilesChange(files);
        }, 100);
        /* super.onFilesChange(files); */
        this.fileList = info.fileList.map((f) => {
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            return obj && obj.length > 0 ? obj[0] : f;
        });
    }
    unsubscribe() {
        if (this.commandSubscription) {
            this.commandSubscription.unsubscribe();
        }
    }
    setControl() {
        if (this.ctrl && this.ctrl.value) {
            this.toFilelist(this.ctrl.value);
        }
        else {
            // this.fileList = [];
            this.uploadFileList = this.fileList = [];
        }
        this.unsubscribe();
        this.listenCommand();
    }
    handleValueChange(value, changeInfo) {
        // 图片有两种情况,
        // 上传图片和被动赋值.
        // 如果是主动上传图片则不应该 调用this.toFilelist.
        // 如果是赋值则可以调用this.toFilelist. 目前看来每次更新赋值前 value会被设置null.
        if (!value) {
            this.toFilelist(value);
        }
        else if (value.length &&
            (!this.uploadFileList || this.uploadFileList.length === 0)) {
            this.toFilelist(value);
        }
        else if (value && value.length >= 0) {
            this.toFilelist(value);
        }
        else if (value.length === this.uploadFileList.length) {
        }
    }
    toFilelist(val) {
        if (!val) {
            this.uploadFileList = this.fileList = [];
            return;
        }
        //说明此时的数据还未经过转换
        if (Array.isArray(val) && val.length > 0 && val[0].mimeType) {
            val = this.convertFileData(val);
            if (!val)
                return;
        }
        this.uploadFileList = this.fileList = val.map((y) => {
            let x = "";
            if (!y.uid && y.response && y.response.data) {
                x = y.response.data;
            }
            else {
                x = y;
            }
            if (x.response && x.response.data) {
                x.url = x.url || '';
                x.previewUrl = x.previewUrl || '';
            }
            return x;
        });
    }
    listenCommand() {
        const _this = this;
        this.commandSubscription = this.ctrl.commander.subscribe((cmd) => {
            switch (cmd.name) {
                case "clear":
                    _this.fileList = [];
                    _this.ctrl.value = null;
                    break;
                default:
                    break;
            }
        });
    }
    showError(msg) {
        message.error(msg);
    }
    beforeUpload(file) {
        if (!this.checkFileType(file.name, this.showError)) {
            return false;
        }
        if (!this.checkFileSize(file, this.showError)) {
            return false;
        }
        if (!this.checkImageNumber(this.showError)) {
            return false;
        }
        if (!this.checkImageNameLength(file.name, this.showError)) {
            return false;
        }
        file.uploadTime = new Date().getTime();
        let userInfo = window.sessionStorage.getItem("user");
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
        }
        else {
            userInfo = { name: "" };
        }
        file.uploadName =
            window.sessionStorage.getItem("uploadName") || userInfo.name;
        // let param1 = {
        //   "fileName": file.name,
        //   "fileSize": file.size
        // }
        // let url1 =  '/api/oss/upload/signurl';
        // let res1:any = await axios.post(url1, param1);
        // let uploadHeaders = Object.assign({},res1.data.headers,res1.data.metaData);
        // let {refId, signUrl} = res1.data;
        // this.largeUploadUrl = signUrl;
        // this.largeUploadHeaders = uploadHeaders;
        return true;
    }
    /**
     * @des 删除文件
     */
    rmFile(file) {
        console.log(file, "file");
        this.uploadFileList = this.uploadFileList.filter((u) => u.uid !== file.uid);
        this.removedFile(file);
    }
    onRemovedImg(file) {
        super.removedFile(file);
    }
    previewFile(file) {
        if (file.status === 2 || file.status === "done") {
            this.handlePreview(file);
        }
    }
    // 二开 附件上传排序处理
    changeFileListSort(key) {
        console.log(key, this.fileList, "fileList");
        console.log(this.uploadFileList, "uploadFileList");
        this.up(key);
    }
    changeFileListSortDown(key) {
        console.log(key, this.fileList, "fileListDown");
        console.log(this.uploadFileList, "uploadFileList");
        this.down(key);
    }
    down(i) {
        let downDate = this.fileList[i + 1];
        this.fileList.splice(i + 1, 1);
        this.fileList.splice(i, 0, downDate);
        console.log(this.fileList, "222222223333333444");
        this.uploadFileList = this.fileList;
        this.setValue(this.uploadFileList);
    }
    up(i) {
        let upDate = this.fileList[i - 1];
        this.fileList.splice(i - 1, 1);
        this.fileList.splice(i, 0, upDate);
        console.log(this.fileList, "222222223333333444");
        this.uploadFileList = this.fileList;
        this.setValue(this.uploadFileList);
    }
    // 二开end
    handleCancel() {
        this.previewVisible = false;
    }
    isImageFileType(filename) {
        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg", ".webp"];
        const fileExtension = filename.slice(filename.lastIndexOf("."));
        return imageExtensions.includes(fileExtension.toLowerCase());
    }
    handlePreview(file) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // console.log(file)
            if (file.previewUrl) {
                file.previewUrl && window.open(file.previewUrl);
                event && event.stopPropagation();
            }
            else {
                let url1 = '/api/oss/download/signurl';
                let params1 = {
                    refId: file.response.data.refId
                };
                let res1 = yield axios.post(url1, params1);
                let downloadUrl = res1.data.signUrl;
                let type = file.type || file.response.data.mimeType;
                if ((type && type.indexOf("image") !== -1) || (!type && this.isImageFileType(file.name))) {
                    this.previewImage = downloadUrl;
                    this.previewVisible = true;
                    //   axios({
                    //   url:downloadUrl,
                    //   method:'get',
                    //   responseType:'blob'
                    // }).then((content:any)=>{
                    //   const blob = new Blob([content])
                    //   let href = window.URL.createObjectURL(blob)
                    //   this.previewImage = href;
                    //   this.previewVisible = true;
                    // })
                }
                else if (type.toUpperCase().indexOf("PDF") !== -1) {
                    window.open(downloadUrl);
                }
                else {
                    this.$message.info("Unable to preview this file, please download and view");
                    return;
                }
            }
        });
    }
    // 下载模板文件
    downTemplate() {
        const templateFile = this.controlOpts.templateFile
            ? this.controlOpts.templateFile
            : null;
        if (templateFile) {
            const templateFiles = typeof templateFile === "string"
                ? JSON.parse(templateFile)
                : templateFile;
            const files = templateFiles.map((item) => item.response.data);
            if (files.length === 1) {
                this.download(files[0]);
            }
            else {
                this.downloadAllTemplate(files);
            }
        }
        else {
            return false;
        }
    }
    downloadAll() {
        this.downloadBatch();
    }
    destroyed() {
        super.destroyed();
        this.unsubscribe();
    }
    created() {
        this.init();
    }
};
PcUpload = tslib_1.__decorate([
    Component({
        name: "pc-upload",
        components: {
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
            FileList: FileList,
            ASpin: Spin,
        },
    })
], PcUpload);
export default PcUpload;
